export default __webpack_public_path__ + "static/media/ico_enterprise.5491871b.svg";